import { Button, Tabs } from "antd";
import { FacebookFilled } from "@ant-design/icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Live from "./Tiktok/Live";
import Messaging from "./Tiktok/Messaging";
import Shop from "./Tiktok/Shop";

export default function ConnectTiktokView() {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState("messaging");

    // min-h-0 + overflow-hidden: item của grid mặc định min-height:auto nên vẫn nở
    // theo nội dung và tràn khỏi modal dù khung cha đã cố định chiều cao
    return (
        <div className="md:pl-6 flex flex-col h-full min-h-0 md:overflow-hidden">
            {/* TITLE + SEARCH */}
            <div className="flex justify-between items-center mb-4">
                <div className="text-base font-medium">
                    {t('chats.add_tiktok')}
                </div>
            </div>

            <div className="flex justify-between items-center overflow-x-auto overflow-y-hidden">
                {/* TABS */}
                <Tabs
                    className="connect-tabs min-w-max"
                    activeKey={activeTab}
                    onChange={setActiveTab}
                    items={[
                        {
                            key: "messaging",
                            label: (
                                <div className="flex items-center gap-2">
                                    TikTok Business Messaging
                                </div>
                            ),
                        },
                        {
                            key: "shop",
                            label: (
                                <div className="flex items-center gap-2">
                                    TikTok Shop
                                    <span className="text-red-500 italic text-[12px]">New</span>
                                </div>
                            ),
                        },
                        {
                            key: "live",
                            label: (
                                <div className="flex items-center">
                                    TikTok Livestream AIO
                                </div>
                            ),
                        },
                    ]}
                />
            </div>

            <div className="flex-1 min-h-0 flex flex-col">
                {activeTab === "messaging" && <Messaging />}
                {activeTab === "live" && <Live />}
                {activeTab === "shop" && <Shop />}
            </div>
        </div>
    );
}